// react
import React from 'react';
import styled from 'styled-components';

// typeform
import { Widget } from '@typeform/embed-react';

interface TypeformProps {
  className?: string;
  formID: string;
  onSubmit?: (this: Window, submitEvent: any) => void;
}

/**
 * Typeform renders a Typeform widget.
 */
export const Typeform = ({ className, formID, onSubmit }: TypeformProps) => {
  return <StyledWidget className={className} id={formID} onSubmit={onSubmit} />;
};

const StyledWidget = styled(Widget)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0;
  .tf-v1-widget iframe {
    border-radius: 0;
  }
`;

Typeform.displayName = 'Typeform';

export default Typeform;
